// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"0d5cf067","453":"52d2d40b","590":"98c60197"}[chunkId] + ".chunk.js";
};